import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Loader from "@/components/Loader/LoaderView";
import Swal from "sweetalert2";
import { get_token, get_user_details } from "@/router";


export default {
  components: {
    Sidebar,
    Navbar,
    Loader
  },
  data() {
    return ({
        isSubmitting : false,
        selected_profiles:[],
        selected_profile_types:[],
        selected_profile_tab:null,
        tabs:[],
        profile_types :[],
        editing_tab: null,
        tab_form: {
        id: null,
        name: '',
        is_locked: false
        }
    });
  },
  methods: {
      get_auth_token() {
      return get_token();
    },
    toggle_sidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
        open_create_modal() {
      this.editing_tab = null;
      this.tab_form = { id: null, name: '', is_locked: false };
      $('#tab_modal').modal('show')
    },
    create_tab(tab) {
      this.editing_tab = tab;
      this.tab_form = { ...tab };
      $('#tab_modal').modal('show')
    },
    create_profile_tab() {
    if (!this.tab_form.name) {
      Swal.fire({
        icon: 'error',
        title: 'Tab name is required',
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
      return;
    }

    const formData = new FormData();
    formData.append('name', this.tab_form.name);
    formData.append('is_locked', this.tab_form.is_locked);

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_profile_tab/`,
      method: "POST",
      headers: { Authorization: `Token ${this.get_auth_token()}` },
      data: formData,
      processData: false,
      contentType: false,
      success: (response) => {
        if (response.response_data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Tab created",
            showConfirmButton: false,
            timer: 1000,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            this.tabs.unshift(response.response_data.data); // add the new tab to the table
            $('#tab_modal').modal('hide');
          });
        }
      },
      error: (response) => {
        this.errors.name = response.responseJSON?.message || {};
      }
    });
  },
    update_tab() {
    if (!this.tab_form.name) {
      Swal.fire({
        icon: 'error',
        title: 'Tab name is required',
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
      return;
    }

    const formData = new FormData();
    formData.append('tab_id', this.tab_form.id);
    formData.append('name', this.tab_form.name);
    formData.append('is_locked', this.tab_form.is_locked);

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_profile_tab/`,
      method: "POST",
      headers: { Authorization: `Token ${this.get_auth_token()}` },
      processData: false,
      contentType: false,
      data: formData,
      success: (response) => {
        if (response.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Tab updated",
            showConfirmButton: false,
            timer: 1000,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            Object.assign(this.editing_tab, response.data); // update the local tab
            // this.resettab_form();
            $('#tab_modal').modal('hide');
          });
        }
      },
      error: (response) => {
        this.errors.name = response.responseJSON?.message || {};
      }
    });
  },
  delete_tabs(tabId) {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the tab.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      position: 'bottom-end',
      toast: true
    }).then((result) => {
      if (result.isConfirmed) {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_profile_tab`,
          method: "DELETE",
          headers: { Authorization: `Token ${this.get_auth_token()}` },
          data:{tab_id:tabId},
          success: (response) => {
            if (response.status === "success") {
              Swal.fire({
                icon: "success",
                title: "Tab deleted",
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
              }).then(() => {
                this.tabs = this.tabs.filter(t => t.id !== tabId);
              });
            }
          },
          error: (response) => {
            Swal.fire({
              icon: "error",
              title: response.responseJSON?.message || "Error deleting tab",
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        });
      }
    });
  },

  resettab_form() {
    this.tab_form = { id: null, name: '', is_locked: false };
    this.editing_tab = null;
  },
    get_all_profile_tabs() {
        this.isSubmitting = true;
        return new Promise((resolve) => {
            $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_profile_tabs/`,
          method: 'GET',
          headers: {
            'Authorization': `Token ${this.get_auth_token()}`,
            'Content-Type': 'application/json'
          },
          success: (data) => {
            this.tabs = data.response_data.data;
            this.isSubmitting = false;
            resolve(); 
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      });
    },
    get_profile_types() {
        this.token_exists = get_token();
        $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile_types/`, // Replace with the correct endpoint
        method: "GET",
        headers: { Authorization: `Token ${this.get_auth_token()}` },
        success: (response) => {
            this.profile_types = response.data;
        },
        });
    },
    open_profile_types_modal(tab_id){
        this.selected_profile_tab=tab_id;
        this.selected_profile_types = this.tabs.find((r) => r.id === tab_id).assigned_profile_types.map(item => item.id);
        $("#assignProfileTabs").modal('show')
    },
    assign_profile_tab() {
    if (!this.selected_profile_tab || this.selected_profile_types.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Selection Required",
        text: "Please select a tab and at least one profile type.",
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
      return;
    }

    const assignmentData = {
      profile_tab_id: this.selected_profile_tab,
      profile_type_ids: this.selected_profile_types,
    };


    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/assign_profile_tabs/`,
      method: "POST",
      headers: { Authorization: `Token ${this.get_auth_token()}` },
      data: JSON.stringify(assignmentData),
      contentType: "application/json",
      success: (response) => {
        if (response.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Tab Assigned",
            text: "The tab has been successfully assigned to the selected profiles.",
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            // reset selections
            this.selected_profile_tab = null;
            this.selected_profile_types = [];
            $("#assignProfileTabs").modal('hide');
          });
        }
      },
      error: (response) => {
            Swal.fire({
            icon: "error",
            text: response.responseJSON.message,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
            });
        },
    });
  },
  },
  mounted() {
    this.get_profile_types();
    this.user_details = get_user_details();
    this.get_all_profile_tabs().then(() => {
      this.$nextTick(() => {
        $('.table').DataTable({
          paging: true,
          searching: true, 
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
           sortColumn: '',
           sortDirection: 'asc'
        });
      });
    });
    
  }
};
